<template>
  <div class="rule-report-view">
    <div v-if="!rule" class="flex justify-center py-20">
      <loader-circle-icon class="size-8 animate-spin text-primary" />
    </div>
    <report-view
      v-else
      :ad-account-id="rule.ad_account.id"
      :campaign-id="rule.output_campaign.id"
      :action="action"
      :period="period"
    />
  </div>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

import ReportView from '@/ui/views/ReportView.vue';

export default {
  name: 'RuleReportView',
  components: {
    LoaderCircleIcon: LoaderCircle,
    ReportView,
  },
  inject: [ 'ruleView' ],
  computed: {
    rule() {
      return this.ruleView.rule;
    },
    action() {
      let action = null;
      if (this.rule.settings?.adset_optimization_goal === 'PAGE_LIKES') {
        return 'like';
      }
      switch (this.rule.output_campaign.objective) {
        case 'TRAFFIC':
        case 'OUTCOME_TRAFFIC':
          action = 'landing_page_view';
          break;

        case 'POST_ENGAGEMENT':
        case 'OUTCOME_ENGAGEMENT':
          action = 'post_engagement';
          break;

        case 'CONVERSIONS':
        case 'OUTCOME_SALES':
          if (this.rule.conversion_event === 'PURCHASE') {
            action = 'omni_purchase';
          }
          else if (this.rule.conversion_event) {
            action = this.rule.conversion_event.toLowerCase() + '_total';
          }
          break;

        default:
          if (this.rule.conversion_event) {
            action = this.rule.conversion_event.toLowerCase() + '_total';
          }
      }

      return action;
    },
    period() {
      const yesterdayMidnight = new Date();
      yesterdayMidnight.setDate(yesterdayMidnight.getDate() - 1);
      yesterdayMidnight.setHours(0, 0, 0, 0);
      if (this.rule.created_at >= yesterdayMidnight) {
        return 'today_and_yesterday';
      }

      return 'last_30d';
    },
  },
};
</script>
